module.exports = __webpack_public_path__ + "img/icon_partner_type_01.9be74b1a.svg";